import {sanitizeFileName} from './csvExport';

// Browser download via the same Blob → object-URL → anchor idiom as `downloadCsv`.
// Lives apart from pdfExport (which imports the heavy @react-pdf/renderer) so the
// button can trigger a download WITHOUT pulling react-pdf into the main thread.
export const downloadPdf = (fileName: string, blob: Blob): void => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${sanitizeFileName(fileName)}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
